import BaseTree from './base-tree.vue'
BaseTree.install = function (Vue) {
  Vue.component(BaseTree.name, BaseTree);
};
export default BaseTree



// WEBPACK FOOTER //
// ./src/omnis-business/base-tree/index.js